import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "flatpickr/dist/flatpickr.css";
import { FormattedMessage, useIntl } from "react-intl";
import Loader from "components/shared/Loader";
import { addSection, getAllPageSections } from "store/actions";
import AddButton from "components/shared/AddButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
// import ImageUpload from "components/shared/ImageUpload";
import ReactSelect from "react-select";
import SlidersArray from "./SliderArray";
import { Editor } from "components/shared/Editor";
import ImageUpload from "components/shared/ImageUpload";
import { Input } from "components/shared/FormComponents";
const AddProjects = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    loading,
    error,
    sections: categories,
  } = useSelector((state) => state.section);

  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const [sliders, setSliders] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  // effects
  useEffect(() => {
    dispatch(getAllPageSections("projectsCategories"));
  }, [dispatch]);
  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    if (!selectedImage?.path) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }
    data.image = selectedImage?.path;
    data.title = data?.heading?.en;
    data.sections = sliders;

    dispatch(
      addSection({
        page: "projects-1",
        data: { section: data },
        navigate: () => navigate("/projects"),
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"addItem"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                {/* heading  */}
                <Row>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"image"} />
                      </h5>
                      <ImageUpload
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col xs="12" md="6">
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} /> (
                        <FormattedMessage id="arabic" />)
                      </h5>

                      <Controller
                        control={control}
                        name={`description.ar`}
                        render={({ field: { value, onChange } }) => (
                          <Editor
                            type="text"
                            initialValue={value}
                            className={`form-control form-outline`}
                            onChange={(_, editor) => {
                              const data = editor.getContent();
                              onChange(data);
                            }}
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col xs="12" md="6">
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} /> (
                        <FormattedMessage id="english" />)
                      </h5>

                      <Controller
                        control={control}
                        name={`description.en`}
                        render={({ field: { value, onChange } }) => (
                          <Editor
                            type="text"
                            initialValue={value}
                            className={`form-control form-outline`}
                            onChange={(_, editor) => {
                              const data = editor.getContent();
                              onChange(data);
                            }}
                          />
                        )}
                      />
                    </div>
                  </Col>

                  {/* <Col lg={12} xs={12}>
                    <Input
                      langId="percent"
                      name="percent"
                      register={register}
                      errors={errors}
                    />
                  </Col> */}
                  <Col lg={6} xs={12}>
                    <Input
                      langId="seoSpeed"
                      name="seoSpeed.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="seoSpeed"
                      name="seoSpeed.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="websiteSpeed"
                      name="websiteSpeed.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="websiteSpeed"
                      name="websiteSpeed.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="programmingType"
                      name="programmingType.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="programmingType"
                      name="programmingType.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>

                  <Col>
                    <div className="form-group ">
                      <h5>
                        <FormattedMessage id="category" />
                      </h5>

                      <Controller
                        control={control}
                        name="category"
                        rules={{ required: true }}
                        render={({ field: { onChange, value, name, ref } }) => (
                          <ReactSelect
                            inputRef={ref}
                            name={name}
                            placeholder={<FormattedMessage id={"category"} />}
                            options={categories?.map((c) => ({
                              value: c?.slug,
                              label: c?.heading?.[locale],
                            }))}
                            onChange={(selectedOption) => {
                              onChange(selectedOption.value);
                            }}
                            isRtl={true}
                            isSearchable={false}
                            className="basic-single"
                            classNamePrefix="select"
                          />
                        )}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        <FormattedMessage id={"add"} />
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProjects;
